var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "custom-tree",
    },
    [
      _c("div", { staticClass: "selectFilterNum" }, [
        _vm._v("已选择: "),
        _c("span", { staticStyle: { color: "#5088FF", "font-size": "13px" } }, [
          _vm._v(_vm._s(_vm.selectFilterNum)),
        ]),
        _vm._v("个筛选条件"),
      ]),
      _c("custom-tree-group", {
        attrs: { change: _vm.onChange, isRoot: true },
        on: { deletechildren: _vm.deleteChildren },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }